import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { succsesDataChangeAlert } from "../../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../../redux/services/crmAPI";
import { useGetPageUnloadQuery } from "../../../redux/services/noLoadingReqAPI";
import AddPositionMoveSelect from "../../addPositionMoveSelect/AddPositionMoveSelect";
import "./modalMove.scss";

const ModalMove = ({ showMoveModal, setShowMoveModal }) => {
    const handleClose = () => setShowMoveModal(false);

    const searchPositionRef = useRef();
    const inputPositionRef = useRef();

    const [productSearchInput, setProductSearchInput] = useState("");
    const [store, setStore] = useState(0);
    const [reason, setReason] = useState("");
    const [showSearchPositionList, setShowSearchPositionList] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedPositionsQuantity, setSelectedPositionQuantity] = useState([]);

    const { data: stores } = useGetPageQuery("stores?per_page=100&is_move=1&all_stores=1", { skip: !showMoveModal });
    const { data: orderPositions, refetch: refetchPosiitions } = useGetPageUnloadQuery(
        "products?per_page=15&page=1&quantity=1&search=" + productSearchInput,
    );

    const [sendForm, { isLoading, isError, isSuccess }] = useSendFormMutation();

    const addPositionHandler = (position) => {
        setSelectedProducts((products) => [...products, position]);
        setSelectedPositionQuantity([...selectedPositionsQuantity, { id: position.id, qty: 1 }]);
        setProductSearchInput("");
        setShowSearchPositionList(false);
    };

    const changePositionCount = (id, value) => {
        const modedPosition = selectedPositionsQuantity.find((position) => position.id === id);
        modedPosition.qty = +value;
        setSelectedPositionQuantity([
            ...selectedPositionsQuantity.filter((position) => position.id !== id),
            modedPosition,
        ]);
    };

    const removePositionHandler = (positionId) => {
        setSelectedProducts((products) => [...products.filter((procuct) => procuct.id !== positionId)]);
        setSelectedPositionQuantity((positions) => [...positions.filter((position) => position.id !== positionId)]);
    };

    const sendFormHandler = async () => {
        const formData = { products: selectedPositionsQuantity, store_id: store, reason: reason };

        await sendForm({ body: formData, url: `transfers/move`, method: "POST" }).unwrap();
        refetchPosiitions();

        setSelectedPositionQuantity([]);
        setSelectedProducts([]);
    };

    useEffect(() => {
        if (isSuccess) {
            refetchPosiitions();
            setSelectedPositionQuantity([]);
            setSelectedProducts([]);
            succsesDataChangeAlert();
        }
    }, [isSuccess]);

    useEffect(() => {
        refetchPosiitions();
    }, [showMoveModal]);

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (
                inputPositionRef.current &&
                !e.composedPath().includes(inputPositionRef.current) &&
                searchPositionRef.current &&
                !e.composedPath().includes(searchPositionRef.current)
            ) {
                setShowSearchPositionList(false);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    return (
        <Modal
            show={showMoveModal}
            onHide={handleClose}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Перенести товари в інший магазин</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {stores && (
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="form-label">Виберіть товари</label>
                            <input
                                type="text"
                                className="form-control"
                                value={productSearchInput}
                                onChange={(e) => setProductSearchInput(e.target.value)}
                                ref={inputPositionRef}
                                onFocus={() => setShowSearchPositionList(true)}
                                autocomplete="off"
                            />

                            <div ref={searchPositionRef}>
                                {showSearchPositionList && (
                                    <AddPositionMoveSelect
                                        orderPositions={orderPositions.data}
                                        addPositionHandler={addPositionHandler}
                                        positions={selectedPositionsQuantity}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="transfers">
                            <table className="table table-striped transfer_table">
                                <tbody>
                                    {selectedProducts.map((product) => {
                                        return (
                                            <tr
                                                className="crow"
                                                key={product.id}
                                            >
                                                <td className="middle_name">
                                                    <input
                                                        type="hidden"
                                                        name="transfer[product_id][]"
                                                        value="137947"
                                                    />
                                                    <span
                                                        className="transfer_name"
                                                        data-id="137947"
                                                    >
                                                        {`${product?.title} ${
                                                            product?.imei_sn ? `(${product?.imei_sn.slice(-5)})` : ""
                                                        }`}
                                                    </span>
                                                    <span className="product_store">{product?.store.title}</span>
                                                </td>

                                                <td className="middle_name text-right">
                                                    <span className="transfer_price">{product?.price}</span>
                                                    &nbsp;грн.
                                                </td>

                                                <td className="middle_name text-right">
                                                    <span className="transfer_amount">{product?.quantity}</span>
                                                    &nbsp;шт
                                                </td>

                                                <td className="middle_name text-right">
                                                    <div
                                                        className="input-group edit_purchase"
                                                        style={{ width: "108px" }}
                                                    >
                                                        <input
                                                            type="text"
                                                            value={
                                                                selectedPositionsQuantity.find(
                                                                    (position) => position.id === product.id,
                                                                ).qty
                                                            }
                                                            className="form-control"
                                                            onChange={(e) =>
                                                                changePositionCount(product.id, e.target.value)
                                                            }
                                                        />
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">шт</span>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="micro text-right">
                                                    <i
                                                        className="bi bi-trash fake-a"
                                                        onClick={() => removePositionHandler(product.id)}
                                                    ></i>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Виберіть магазин</label>
                            <select
                                name="store_id"
                                className="form-select"
                                value={store}
                                onChange={(e) => setStore(e.target.value)}
                            >
                                {stores.data.map((store) => {
                                    return (
                                        <option
                                            value={store.id}
                                            key={store.id}
                                        >
                                            {store.title}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="form-group mt-3">
                            <label className="form-label">Зазаначте причину переносу на сервіс</label>
                            <input
                                name="reason"
                                className="form-control"
                                type="text"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                            />
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={sendFormHandler}
                >
                    {isLoading ? "Завантаження" : "Змінити"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalMove;
